import { apiEndpoint, requestPayload } from '../utils/common';
import { post } from '../utils/http';
import { API } from '../constant';

export function applyPromo(details) {
  return post.call(this, apiEndpoint(API.APPLY_PROMO), requestPayload(details));
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/offers.js